module.exports = __webpack_public_path__ + "heart-blood-vessel-anatomy.9ec187e98774a1c40f9b54fec513876c.png";